import React from "react";
import { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import {
  fetchDonationTypeApi,
  addDonationTypeApi,
  updateDonationTypeApi,
  addSubTypeApi,
  updateDonationTypeChildApi,
  deleteChildDonationType,
  deleteDonationType,
} from "../api/DonationTypes";
import toast from "react-hot-toast";
import DeleteItem from "./DeleteItem";
import SideModal from "../../Components/general/Sidemodal";

interface DonationTypeProps {
  url: string;
}

export const DonationType = ({ url }: DonationTypeProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddingSubType, setIsAddingSubType] = useState(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [isEditSubType, setIsEditSubType] = useState<boolean>(false);

  const [name, setName] = useState<string>("");
  const [selectedDonationType, setSelectedDonationType] = useState<any>(null);

  const [donationType, setDonationType] = useState<any[]>([]);
  const [expandedRows, setExpandedRows] = useState<number[]>([]);

  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [selectedItem, setSelectedItem] = useState<{ id: string } | null>(null);

  const [isModalOpenSubType, setIsModalOpenSubType] = useState(false);
  const [selectedItemSubType, setSelectedItemSubType] = useState<{ id: string } | null>(null);

  const fetchDonationTypeData = async () => {
    const data = await fetchDonationTypeApi(url);

    if (data && Array.isArray(data)) {
      setDonationType(data);
    } else {
      console.error("Failed to fetch taxonomies");
    }
  };

  useEffect(() => {
    fetchDonationTypeData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(donationType.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const parentDonationTypes = donationType.filter(
    (don) => don.parentId === null
  );

  const paginatedDonation = parentDonationTypes.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleEditClick = (donation: any) => {
    setIsModalOpen(true);
    setIsEditMode(true);
    setIsAddingSubType(false);
    setIsEditSubType(false);
    setName(donation.name);
    setSelectedDonationType(donation);
  };

  const handleAddSubTypeClick = (donation: any) => {
    setIsModalOpen(true);
    setIsEditMode(false);
    setIsAddingSubType(true);
    setIsEditSubType(false);
    setSelectedDonationType(donation);
    setName("");
  };

  const handleAddClick = () => {
    setIsModalOpen(true);
    setIsEditMode(false);
    setIsAddingSubType(false);
    setIsEditSubType(false);
  };

  const handleEditSubTypeClick = (donation: any) => {
    setIsModalOpen(true);
    setIsEditSubType(true);
    setIsEditMode(false);
    setIsAddingSubType(false);
    setName(donation.name);
    setSelectedDonationType(donation);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setName("");
  };

  const handleSubmitClick = async () => {
    if (!name) {
      toast.error("Please fill details");
      return;
    }

    try {
      if (isEditMode) {
        await updateDonationTypeApi(url, selectedDonationType.id, name);
        toast.success("Donation Type updated successfully");
      } else if (isAddingSubType) {
        await addSubTypeApi(url, selectedDonationType.id, name);
        toast.success("Donation Sub Type Added successfully");
      } else if (isEditSubType) {
        await updateDonationTypeChildApi(
          url,
          selectedDonationType.id,
          selectedDonationType.parentId,
          name
        );
      } else {
        await addDonationTypeApi(url, name);
        toast.success("Donation Type added successfully");
      }

      fetchDonationTypeData();
      handleCloseModal();
    } catch (error) {
      toast.error(`Failed to ${isEditMode ? "update" : "add"} donation type`);
    }
  };

  const toggleRowExpansion = (taxonomyId: number) => {
    setExpandedRows((prevExpandedRows) =>
      prevExpandedRows.indexOf(taxonomyId) !== -1
        ? prevExpandedRows.filter((id) => id !== taxonomyId)
        : [...prevExpandedRows, taxonomyId]
    );
  };

  const handleSubTypeDeleteClick = (id: string) => {
    setSelectedItemSubType({ id });
    setIsModalOpenSubType(true);
  };

  const confirmDeleteSubType = async () => {
    if (!selectedItemSubType) return;

    try {
      await deleteChildDonationType(url, selectedItemSubType.id);
      toast.success("Child deleted successfully");
      fetchDonationTypeData();
    } catch (error) {
      console.error(fetchDonationTypeData());
    } finally {
      setIsModalOpenSubType(false);
      setSelectedItemSubType(null);
    }
  };

  const handleDonationTypeDeleteClick = (id: string) => {
    setSelectedItem({ id });
    setIsModalOpen1(true);
  };

  const confirmDelete = async () => {
    if (!selectedItem) return;

    try {
      await deleteDonationType(url, selectedItem.id);
      toast.success("Donation Type deleted successfully");
      fetchDonationTypeData();
    } catch (error) {
      console.error("Error deleting donation type:", error);
    } finally {
      setIsModalOpen1(false);
      setSelectedItem(null);
    }
  };

  return (
    <div className="px-2 md:px-4 mt-6 h-full">
      <div>
        <div className='flex flex-row items-center  '>
          <h1 className="text-3xl font-bold text-blue-600 ">
            Donation Type
          </h1>
          <button
            type="button"
            className=" w-fit px-3 py-2 mx-3 tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
            onClick={handleAddClick}
          >
            <FaPlus className="w-3 h-3" />
          </button>
        </div>
        <div className="flex-grow ml-0 w-full mt-10">
          <form className="w-full ">
            <label
              htmlFor="default-search"
              className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
            >
              Search
            </label>
            <div className="relative w-full">
              <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                type="search"
                id="default-search"
                className="inline-block min-w-full p-3 ps-10 outline-none text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Search Taxonomies"
                required
              />
              <button
                type="submit"
                className="text-white absolute end-1.5 bottom-1.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Search
              </button>
            </div>
          </form>
        </div>
        <div className="flex-grow ml-0 w-3/4">
          <form className="w-auto">{/* Search Form */}</form>
        </div>
        <div className="flex-grow ml-0 mt-4 w-full">
          <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg mt-6">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead className="bg-gray-50 dark:bg-gray-800">
                <tr>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                    style={{ width: "200px" }}
                  >
                    Actions
                  </th>
                  <th
                    scope="col"
                    className="py-3.5 px-4 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                  >
                    Name
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                {paginatedDonation.map((don, index) => {
                  const hasChildren = donationType.some(
                    (item) => item.parentId === don.id
                  );
                  return (
                    <React.Fragment key={don.id}>
                      <tr key={don.id || index}>
                        <td className="px-4 py-4 text-sm whitespace-nowrap">
                          <div className="flex items-center gap-x-6">
                            <button
                              onClick={() =>
                                handleDonationTypeDeleteClick(don.id)
                              }
                              type="button"
                              className="text-gray-500 transition-colors duration-200 dark:hover:text-red-600 dark:text-gray-300 hover:text-red-500 focus:outline-none"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="w-5 h-5"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                />
                              </svg>
                            </button>

                            <button
                              type="button"
                              onClick={() => handleEditClick(don)}
                              className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
                            >
                              {/* Edit icon */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className="w-5 h-5"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                />
                              </svg>
                            </button>
                            {/* add subtype button */}
                            <button
                              type="button"
                              onClick={() => handleAddSubTypeClick(don)}
                              className="text-gray-500 transition-colors duration-200 dark:hover:text-blue-500 dark:text-gray-300 hover:text-blue-500 focus:outline-none"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="w-5 h-5"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M12 4.5v15m7.5-7.5h-15"
                                />
                              </svg>
                            </button>
                            <div>
                              {hasChildren && (
                                <button
                                  type="button"
                                  onClick={() => toggleRowExpansion(don.id)}
                                  className="text-gray-500 transition-colors duration-200 dark:hover:text-blue-600 dark:text-gray-300 hover:text-blue-500 focus:outline-none"
                                >
                                  {expandedRows.indexOf(don.id) !== -1 ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth="1.5"
                                      stroke="currentColor"
                                      className="w-5 h-5"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M19.5 15.75l-7.5-7.5-7.5 7.5"
                                      />
                                    </svg>
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth="1.5"
                                      stroke="currentColor"
                                      className="w-5 h-5"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                                      />
                                    </svg>
                                  )}
                                </button>
                              )}
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-700 whitespace-nowrap">
                          <div className="inline-flex items-center gap-x-3">
                            <div className="flex items-center gap-x-2">
                              <div>
                                <h2 className="  text-sm font-medium text-gray-800 dark:text-white ">
                                  {don.name}
                                </h2>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      {/* Nested table */}
                      {expandedRows.indexOf(don.id) !== -1 && (
                        <tr>
                          <td colSpan={2}>
                            <table className="min-w-full divide-y ">
                              <thead className="bg-gray-50 dark:bg-gray-800">
                                <tr>
                                  <th
                                    scope="col"
                                    className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                                    style={{ width: "200px" }}
                                  >
                                    Actions
                                  </th>
                                  <th
                                    scope="col"
                                    style={{ width: "1000px" }}
                                    className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400 w-[23%]"
                                  >
                                    Name
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {donationType
                                  .filter((item) => item.parentId === don.id)
                                  .map((child, key) => (
                                    <tr key={key}>
                                      <td className="px-4 py-4 text-sm whitespace-nowrap">
                                        <div className="flex items-center gap-x-6">
                                          <button
                                            onClick={() =>
                                              handleSubTypeDeleteClick(child.id)
                                            }
                                            type="button"
                                            className="text-gray-500 transition-colors duration-200 dark:hover:text-red-600 dark:text-gray-300 hover:text-red-500 focus:outline-none"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              strokeWidth="1.5"
                                              stroke="currentColor"
                                              className="w-5 h-5"
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                              />
                                            </svg>
                                          </button>

                                          <button
                                            onClick={() =>
                                              handleEditSubTypeClick(child)
                                            }
                                            className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              strokeWidth="1.5"
                                              stroke="currentColor"
                                              className="w-5 h-5"
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                              />
                                            </svg>
                                          </button>
                                        </div>
                                      </td>
                                      <td className="px-4 py-2 text-sm text-gray-500 dark:text-gray-400">
                                        <h2 className="  text-sm font-medium text-gray-800 dark:text-white ">
                                          {child.name}
                                        </h2>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>

      
          <SideModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <div
              className={`px-4`}
            >
              <div className="p-6">
                <div className="flex justify-between">
                  <h2 className="text-xl font-bold  text-blue-600 mb-4 ">
                    {isAddingSubType
                      ? "Add Sub Type"
                      : isEditSubType
                        ? "Edit Sub Type"
                        : isEditMode
                          ? "Edit"
                          : "Add"}
                  </h2>
                  <button
                    onClick={handleCloseModal}
                    className="text-xl text-gray-600 dark:text-gray-400 h-6 w-6"
                  >
                    &times;
                  </button>
                </div>

                <>
                  <label className="text-gray-900 dark:text-gray-200 font-semibold">
                    Name
                  </label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter Value"
                    className="w-full px-4 py-2 mt-2 mb-4 border border-gray-300 rounded-md"
                  />
                  <div className="flex space-x-4 justify-end">
                    <button
                      onClick={handleSubmitClick}
                      className="px-8 py-2.5 leading-5 text-white transition-colors duration-300 transform bg-blue-600 rounded-md hover:bg-blue-500 focus:outline-none focus:bg-gray-600"
                    >
                      {isEditMode || isEditSubType ? "Update" : "Add"}
                    </button>
                    <button
                      onClick={handleCloseModal}
                      className="px-8 py-2.5 leading-5 bg-gray-300 rounded-md"
                    >
                      Cancel
                    </button>
                  </div>
                </>
              </div>
            </div>
          </SideModal>
          <div className="flex items-center justify-between mt-6">
            <button
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
              className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-5 h-5 rtl:-scale-x-100"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                />
              </svg>

              <span>previous</span>
            </button>

            <div className="items-center hidden lg:flex gap-x-3">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageClick(index + 1)}
                  className={`px-2 py-1 text-sm ${currentPage === index + 1
                    ? "text-blue-500 bg-blue-100"
                    : "text-gray-500 hover:bg-gray-100"
                    } rounded-md`}
                >
                  {index + 1}
                </button>
              ))}
            </div>
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
            >
              <span>Next</span>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-5 h-5 rtl:-scale-x-100"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      {isModalOpen1 && (
        <DeleteItem onClose={() => setIsModalOpen1(false)} onConfirm={confirmDelete} />
      )}
      {isModalOpenSubType && (
        <DeleteItem onClose={() => setIsModalOpenSubType(false)} onConfirm={confirmDeleteSubType} />
      )}
    </div>
  );
};
